export const orange = '#FE7C40'
export const red = '#F40F0F'
export const black = '#000000'
export const white = '#FFFFFF'
export const grey = '#BFBFBF'